import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { InvoiceService } from '../data/invoice.service';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Injectable()
export class InvoiceExportWithInvoiceRowsCommandHandler implements ICommandHandler {
  constructor(private _dataService: InvoiceService, private _nativeWindow: NativeWindowService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof FilteredCommand) {
      return this._dataService
        .exportWithInvoiceRows(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
    if (command instanceof MultiselectCommand) {
      return this._dataService
        .exportWithInvoiceRows({}, command.items.map(item => item.id), [], command.items.length)
        .pipe(
          map(file => {
            this._nativeWindow.save(file);
          })
        );
    }
  }
}
